<template>
  <div>
    <header class="c-navheader">
      <button
        class="c-navheader__logo"
        type="button"
        aria-label="トップページへ"
        @click="toTopPage"
      >
        <img :src="logoUrl" alt="paylight X" />
      </button>
      <button
        v-if="props.showMenu && isAuthenticated(new Date())"
        class="c-navheader__menu"
        type="button"
        aria-label="メニュー"
        @click="toggleMenu"
      >
        <IconMenuLine :size="24" :color="MENU_ICON_COLOR" />
      </button>
    </header>
    <CommonsSideMenu :is-open="isOpen" @close="toggleMenu" @select="select" />
  </div>
</template>

<script lang="ts" setup>
import '~/styles/_global.scss'
import '~/styles/troodon/_variables.scss'

import { navigateTo } from '#app'
import logoUrl from '~/assets/paylight-logo.png'
import IconMenuLine from '~/components/icon/menu-line.vue'

const MENU_ICON_COLOR = '#878d96'
const props = defineProps({
  showMenu: {
    type: Boolean,
    default: true,
  },
})

const { isAuthenticated } = useAuth()

const toTopPage = () => {
  window.location.href = '/'
}

const isOpen = ref(false)
const toggleMenu = () => {
  isOpen.value = !isOpen.value
}

const route = useRoute()
watch(
  route,
  () => {
    isOpen.value = false
  },
  { deep: true, immediate: true }
)

// entryフロー中(/entry/)からの遷移は復帰先を redirect_url で引き継ぐ。
// クエリは redirect-setter middleware を持つページ(me/edit, credit-card系等)でのみ消費される。
const select = (path: string) => {
  isOpen.value = false
  if (path === '/sign-out/') {
    navigateTo('/sign-out/')
    return
  }
  navigateTo({
    path,
    query: route.path.match(/\/entry\//)
      ? { redirect_url: encodeURIComponent(route.fullPath) }
      : undefined,
  })
}
</script>

<style scoped lang="scss">
.c-navheader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 24px;
  border-bottom: 1px solid var(--troodon-c-border-low);
  background-color: var(--troodon-c-white);
}

.c-navheader__logo {
  display: block;
  width: 170px;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 51px;
    object-fit: cover;
  }
}

.c-navheader__menu {
  position: absolute;
  top: 50%;
  right: 24px;
  display: flex;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background-color: transparent;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
